import { Button } from "@/components/ui/button";
import { Link } from "react-router-dom";
import { ArrowRight } from "lucide-react";
import { useLanguage } from "@/contexts/LanguageContext";
const heroContent = {
  sv: {
    h1Lead: "Kupoler för",
    h1Main: "Trädgård, Glamping, Växthus, Uterum & Boende",
    h2: "Sveriges bredaste utbud av geodetiska kupoler — för året runt-bruk",
    cta1: "Se vårt utbud",
    cta2: "Till Webshoppen"
  },
  en: {
    h1Lead: "Domes for",
    h1Main: "Garden, Glamping, Greenhouse, Sunroom & Living",
    h2: "Sweden's broadest range of geodesic domes — for year-round use",
    cta1: "View Our Range",
    cta2: "To the Webshop"
  },
  de: {
    h1Lead: "Kuppeln für",
    h1Main: "Garten, Glamping, Gewächshaus, Wintergarten & Wohnen",
    h2: "Das breiteste Angebot geodätischer Kuppeln — für Ganzjahresnutzung",
    cta1: "Unser Sortiment ansehen",
    cta2: "Zum Webshop"
  }
};

export const Hero = () => {
  const { language } = useLanguage();
  const t = heroContent[language];

  return (
    <section className="relative min-h-screen flex items-center justify-center overflow-hidden pt-20" aria-label="Hero section">

      {/* Original 4:3 photo, full-viewport hero */}

      <picture className="absolute inset-0 z-0">
        <source
          media="(max-width: 768px)"
          type="image/webp"
          srcSet="/hero-dome-new-mobile.webp"
        />
        <source
          type="image/webp"
          srcSet="/hero-dome-new.webp"
        />
        <img
          src="/hero-dome-new.webp"
          alt="Transparent panoramakupol från Diamond Domes i en grönskande trädgård"
          loading="eager"
          fetchPriority="high"
          decoding="async"
          width={1280}
          height={960}
          sizes="100vw"
          className="w-full h-full object-cover object-center brightness-[0.85]"
        />
      </picture>
      
      <div className="absolute inset-0 hero-scrim z-0" />
      <div className="absolute inset-0 hero-scrim-focus z-0" />
      
      <div className="container mx-auto px-4 md:px-6 relative z-10 text-center animate-fade-in">
        {/* H1 — keyword-rich, two-line composition */}
        <h1 className="font-serif font-bold text-white mb-5 max-w-5xl mx-auto leading-[1.1] tracking-tight hero-title">
          <span className="block text-xl md:text-2xl lg:text-3xl font-light tracking-[0.18em] uppercase text-white/85 mb-3">
            {t.h1Lead}
          </span>
          <span className="block text-3xl md:text-5xl lg:text-6xl">
            {t.h1Main}
          </span>
        </h1>

        {/* H2 — supporting statement */}
        <h2 className="text-base md:text-lg lg:text-xl font-light text-white/95 mb-10 leading-relaxed max-w-2xl mx-auto italic hero-title">
          {t.h2}
        </h2>
        
        <div className="flex flex-col sm:flex-row gap-4 justify-center items-center">
          <Button asChild size="lg" className="gradient-hero text-white hover:opacity-90 transition-smooth shadow-elegant group">
            <Link to="/catalog">
              {t.cta1}
              <ArrowRight className="ml-2 h-5 w-5 group-hover:translate-x-1 transition-smooth" />
            </Link>
          </Button>
          <Button asChild size="lg" variant="outline" className="bg-white/20 border-white/50 text-white hover:bg-white/30 backdrop-blur-sm">
            <Link to="/shop">
              {t.cta2}
            </Link>
          </Button>
        </div>
      </div>
      
      <div className="absolute bottom-8 left-1/2 -translate-x-1/2 z-10 animate-bounce">
        <div className="w-6 h-10 border-2 border-foreground/45 rounded-full flex items-start justify-center p-2">
          <div className="w-1.5 h-3 bg-foreground/45 rounded-full" />
        </div>
      </div>
    </section>
  );
};
